export default {
  zh: {
    delete_tips: '是否将此设备断开连接？ | ',
    disconnect_tips: '断开连接请求已发送，请稍后查看结果（列表中设备已删除即表示断开成功）',
    ok_btn: '断开连接',
    no_btn: '增加设备',
    modify_length_over: '设备名称必须在0-20个字符以内',
    modify_format_error: '设备名称格式错误',
    modify_success: '设备名称修改成功',
    modify_tips: '修改设备名称',
    modify_confirm: '确认',
    modify_cancel: '取消'
  },
  en: {
    delete_tips: 'Are you sure you want to disconnect this device? | ',
    disconnect_tips: 'The disconnection request has been sent, please check the result later (The device removing from the list means the connection disconnected successfully)',
    ok_btn: 'Disconnect',
    no_btn: 'Add Devices',
    modify_length_over: 'Device name must be between 0-20 character',
    modify_format_error: 'Device name format error',
    modify_success: 'Device name modified successfully',
    modify_tips: 'Modify Device Name',
    modify_confirm: 'Confirm',
    modify_cancel: 'Cancel'
  }
}



// WEBPACK FOOTER //
// ./src/views/deviceManagement/lang.js